import React from 'react';
import PermissionHeader from './PermissionHeader';

export default function CommonPermissionHeaders() {
  return (
    <>
      <PermissionHeader title="URLs" tooltip="Allow to create, edit or delete URLs" />
      <PermissionHeader title="Params" tooltip="Allow to create, edit or delete UTM and Custom parameters" />
      <PermissionHeader title="Presets" tooltip="Allow to create, edit or delete Presets, Preset Groups and Parameter Groups" />
      <PermissionHeader title="Project Admin" tooltip="Allow to modify project settings and manage project members." />
    </>
  );
}
